<template>
	<div class="user-performance-graph">
		<div ref="userperformanceGraph" style="width: 100%; height: 100%"></div>
	</div>
</template>

<script>
const eCharts = require("echarts");
var moment = require("moment");

export default {
	name: "userperformanceGraph",
	props: {
		region_average: Array,
		labels: Array,
		country_average: Array,
		chart_data: Array,
		chart_data1: Array,
		reportsTable: Array,
	},
	data() {
		return {
			moment: moment,
			userperformanceGraphInstance: "",
			option: {
				dataZoom: [
					{
						show: false,
						startValue: 0,
						endValue: 10,
						height: 20,
						zoomLock: true,
						zoomOnMouseWheel: false,
						moveOnMouseMove: false,
						moveOnMouseWheel: true,
						preventDefaultMouseMove: true,
						bottom: "0",
					},
					{
						height: 10,
						type: "slider",
						startValue: 0,
						endValue: 100,
						zoomLock: true,
						labelFormatter: "",
						moveOnMouseWheel: true,
					},
					{
						show: false,
						yAxisIndex: 0,
						filterMode: "empty",
						width: 30,
						height: "100%",
						showDataShadow: false,
						zoomLock: true,
						left: "93%",
					},
				],
				color: ["#003546", "#F37413"],
				tooltip: {
					trigger: "axis",
					axisPointer: {
						type: "shadow",
					},
					formatter: (p) => {
						return `Score %  \u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0\u00A0  ${this.getDataByRegion(
							p[0].axisValue,
							"completed_score_%"
						)}% <br/>
						Completion % \u00A0\u00A0\u00A0\u00A0\   ${this.getDataByRegion(
							p[0].axisValue,
							"completion_%"
						)}% <br/>
						`;
					},
				},
				grid: {
					right: "15%",
					y: 40,
					y2: 100,
				},
				legend: {
					data: ["Score %", "Completion %"],
					textStyle: {
						fontSize: "14",
					},
				},
				xAxis: [
					{
						type: "category",
						axisTick: {
							alignWithLabel: true,
						},
						axisLabel: {
							interval: 0,
							rotate: 37, //If the label names are too long you can manage this by rotating the label.
							overflow: "truncate",
							margin: 8,
							hideOverlap: true,
							align: "right",
							verticalAlign: "top",
							lineHeight: 6,
						},
						// prettier-ignore
						data: [],
						textStyle: {
							fontSize: "14",
						},
					},
				],
				yAxis: [
					{
						type: "value",
						name: "",
						min: 0,
						interval: 25,
						max: 100,
						position: "left",
						alignTicks: true,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value} %",
						},
					},
					{
						type: "value",
						name: "",
						min: 0,
						interval: 0,
						max: 1,
						position: "right",
						alignTicks: true,
						axisLine: {
							show: false,
						},
						axisLabel: {
							formatter: "{value} %",
						},
					},
				],
				series: [
					{
						label: {
							normal: {
								show: true,
								position: "top",
								fontSize: 9,
								formatter: "{c}%",
							},
						},
						name: `Score %`,
						type: "bar",
						barGap: "10%",
						barCategoryGap: "10%",
						type: "bar",
						groupPadding: 10,
						yAxisIndex: 0,
						barWidth: "24%",
						data: [],
						itemStyle: {
							// emphasis: {
							//     barBorderRadius: [50, 50]
							// },
							normal: {
								barBorderRadius: [0, 0, 0, 0],
							},
						},
					},
					{
						label: {
							normal: {
								show: true,
								position: "top",
								padding: 0,
								fontSize: 12,
								formatter: "{c}%",
							},
						},
						name: `Completion %`,
						type: "bar",
						barGap: "10%",
						barCategoryGap: "10%",
						type: "bar",
						groupPadding: 10,
						yAxisIndex: 0,
						barWidth: "24%",
						data: [],
						itemStyle: {
							// emphasis: {
							//     barBorderRadius: [50, 50]
							// },
							normal: {
								barBorderRadius: [0, 0, 0, 0],
							},
						},
					},

					{
						name: "",
						type: "line",
						color: "#ff4d01",
						data: [],
					},
					{
						name: "",
						type: "line",
						color: "#b2beb5",
						data: [],
					},
				],
			},
		};
	},
	mounted() {
		setTimeout(() => {
			this.initGraph();
			this.$forceUpdate();
		}, 1200);
	},
	methods: {
		initGraph() {
			const chartContainer = this.$refs.userperformanceGraph;
			this.userperformanceGraphInstance = eCharts.init(chartContainer);
			let labels = [];
			labels = this.labels.filter((el) => {
				if (el != "1st Jan 1970") return el;
			});
			labels = labels.sort(
				(a, b) => this.moment(a).format("x") - this.moment(b).format("x")
			);
			this.option.xAxis[0].data = labels;
			this.option.series[0].data = this.chart_data;
			this.option.series[1].data = this.chart_data1;

			this.option.series[2].data = this.country_average;
			this.option.series[3].data = this.region_average;
			this.userperformanceGraphInstance.setOption(this.option);
		},
		getDataByRegion(region, key) {
			return this.reportsTable.find(
				(el) => this.moment(el.resample_date).format("Do MMM YYYY") == region
			)[key];
		},
	},
};
</script>

<style>
.user-performance-graph {
	height: 400px;
}
</style>
